import { req } from './axiosCreator'

const service = "ResourceService"

export const getResource =  (params) => { return req("get", service + "/getResource" + "/" + params)}

export const getBookDateRange = (params) => { return req("get", service + "/getBookDateRange" + "/" + params)}